<template>
  <div class="attention-table">
    <div class="attention-table__scroll">
      <table>
        <thead>
          <tr>
            <th>Priority</th>
            <th>Item</th>
            <th>Age</th>
            <th><span class="sr-only">Action</span></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(row, index) in items"
            :key="row.key || index"
          >
            <td>
              <el-tag
                size="mini"
                :type="row.priorityType || 'info'"
              >
                {{ row.priority }}
              </el-tag>
            </td>
            <td>
              <strong>{{ row.item }}</strong>
              <small v-if="row.detail">{{ row.detail }}</small>
            </td>
            <td>{{ row.age }}</td>
            <td>
              <el-button
                v-if="row.actionLabel"
                type="text"
                size="mini"
                @click="$emit('action', row)"
              >
                {{ row.actionLabel }}
              </el-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.attention-table__scroll {
  overflow-x: auto;
}

.attention-table table {
  border-collapse: collapse;
  color: #303844;
  min-width: 600px;
  width: 100%;
}

.attention-table th {
  background: #edf0f4;
  color: #4c5664;
  font-size: 11px;
  padding: 9px 10px;
  text-align: left;
}

.attention-table th:first-child {
  border-radius: 4px 0 0 4px;
  width: 140px;
}

.attention-table th:nth-child(3) {
  width: 100px;
}

.attention-table th:last-child {
  border-radius: 0 4px 4px 0;
  width: 100px;
}

.attention-table td {
  border-bottom: 1px solid #ebeef2;
  font-size: 11px;
  padding: 9px 10px;
  vertical-align: middle;
}

.attention-table td:nth-child(2) {
  strong,
  small {
    display: block;
  }

  small {
    color: #8a9099;
    margin-top: 4px;
  }
}

.attention-table td:last-child {
  text-align: right;
}

.sr-only {
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
</style>
